import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	content: {
		maxHeight: 300,
	},
});
